export default __webpack_public_path__ + "static/media/cookware_light.e24a5799.png";